<p-dialog
    appDialogoPadrao="pi pi-building"
    descricao="Atividade tratada na reunião."
    closeAriaLabel="Fechar"
    [header]="titulo()"
    [visible]="visivel()"
    (visibleChange)="visivel.set($event)"
    [style]="{ width: '500px', border: 'none' }"
    styleClass="dialogo-atividade-custom"
    appendTo="body"
    (onHide)="fechar()"
>
    <div [formGroup]="formulario" class="flex flex-col gap-4 py-2 px-1">
        <p class="text-sm text-muted-color">Insira os detalhes da atividade abaixo.</p>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
            <div class="flex flex-col gap-1.5">
                <label for="idTarefaAta" class="text-sm font-semibold text-color">Código da Atividade</label>
                <input id="idTarefaAta" pInputText readonly [value]="formulario.controls.idTarefa.value ? formulario.controls.idTarefa.value : proximoCodigoAtividade() || 'Carregando...'" class="w-full" />
            </div>

            <div class="flex flex-col gap-1.5">
                <label for="idSituacaoTarefaAta" class="text-sm font-semibold text-color">Situação da Atividade</label>
                <p-select
                    inputId="idSituacaoTarefaAta"
                    class="w-full"
                    formControlName="idSituacaoTarefa"
                    [options]="situacoes()"
                    optionLabel="dsSituacaoTarefa"
                    optionValue="idSituacaoTarefa"
                    placeholder="Selecionar situação"
                    appendTo="body"
                ></p-select>
            </div>
        </div>

        <div class="flex flex-col gap-1.5">
            <label class="text-sm font-semibold text-color">Responsável</label>
            <p-select [appendTo]="'body'" class="w-full" formControlName="idResponsavel" [options]="responsaveis()" optionLabel="label" optionValue="id" placeholder="Selecionar Responsável" [filter]="true"></p-select>
        </div>

        <div class="flex flex-col gap-1.5">
            <label for="dsTarefa" class="text-sm font-semibold text-color">Descrição da Atividade</label>
            <textarea id="dsTarefa" pInputText formControlName="descricao" rows="3" placeholder="O que deve ser feito" class="w-full" style="resize: vertical; min-height: 80px"></textarea>
        </div>

        <div class="flex flex-col gap-1.5">
            <label for="txObservacao" class="text-sm font-semibold text-color">Observação / Detalhes</label>
            <textarea id="txObservacao" pInputText formControlName="observacao" rows="3" placeholder="Observações adicionais (opcional)" class="w-full" style="resize: vertical; min-height: 80px"></textarea>
        </div>

        <div class="grid grid-cols-2 gap-3">
            <div class="flex flex-col gap-1.5">
                <label for="dtInicio" class="text-sm font-semibold text-color">Data Início</label>
                <input id="dtInicio" type="date" formControlName="dataInicio" class="w-full p-inputtext p-component" />
            </div>
            <div class="flex flex-col gap-1.5">
                <label for="dtFim" class="text-sm font-semibold text-color">Data Fim</label>
                <input id="dtFim" type="date" formControlName="dataFim" class="w-full p-inputtext p-component" />
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2 pt-2">
            <button type="button" pButton label="Cancelar" severity="secondary" [outlined]="true" (click)="fechar()"></button>
            <button
                type="button"
                pButton
                label="Salvar Atividade"
                severity="primary"
                [disabled]="!formulario.controls.descricao.value || !formulario.controls.idResponsavel.value || !formulario.controls.dataInicio.value || !formulario.controls.idSituacaoTarefa.value"
                [appCan]="roleAtividadesEditar"
                (click)="aoSalvar()"
            ></button>
        </div>
    </ng-template>
</p-dialog>
